export default __webpack_public_path__ + "static/media/activebg.37fa185b.png";